import { languageIds } from './languageIds';

export const metric = {
  in: {
    [languageIds.enUS]: 'mm',
    [languageIds.esES]: 'mm',
    [languageIds.enGB]: 'mm',
    [languageIds.frCA]: 'mm',
    [languageIds.frFR]: 'mm',
    [languageIds.deDE]: 'mm',
  },
  ft: {
    [languageIds.enUS]: 'm',
    [languageIds.esES]: 'm',
    [languageIds.enGB]: 'm',
    [languageIds.frCA]: 'm',
    [languageIds.frFR]: 'm',
    [languageIds.deDE]: 'm',
  },
  sf: {
    [languageIds.enUS]: 'm\u00B2',
    [languageIds.esES]: 'm\u00B2',
    [languageIds.enGB]: 'm\u00B2',
    [languageIds.frCA]: 'm\u00B2',
    [languageIds.frFR]: 'm\u00B2',
    [languageIds.deDE]: 'm\u00B2',
  },
  sy: {
    [languageIds.enUS]: 'm\u00B2',
    [languageIds.esES]: 'm\u00B2',
    [languageIds.enGB]: 'm\u00B2',
    [languageIds.frCA]: 'mètres carrés',
    [languageIds.frFR]: 'mètres carrés',
    [languageIds.deDE]: 'Quadratmeter',
  },
  cf: {
    [languageIds.enUS]: 'm\u00B3',
    [languageIds.esES]: 'm\u00B3',
    [languageIds.enGB]: 'm\u00B3',
    [languageIds.frCA]: 'm\u00B3',
    [languageIds.frFR]: 'm\u00B3',
    [languageIds.deDE]: 'm\u00B3',
  },
  cfs: {
    [languageIds.enUS]: 'L/s',
    [languageIds.enES]: 'L/s',
    [languageIds.enGB]: 'L/s',
    [languageIds.frCA]: 'L/s',
    [languageIds.frFR]: 'L/s',
    [languageIds.deDE]: 'L/s',
  },
  cy: {
    [languageIds.enUS]: 'm\u00B3',
    [languageIds.esES]: 'm\u00B3',
    [languageIds.enGB]: 'm\u00B3',
    [languageIds.frCA]: 'm\u00B3',
    [languageIds.frFR]: 'm\u00B3',
    [languageIds.deDE]: 'm\u00B3',
  },
  inches: {
    [languageIds.enUS]: 'inches',
    [languageIds.esES]: 'pulgadas',
    [languageIds.enGB]: 'inches',
    [languageIds.frCA]: 'mètres',
    [languageIds.frFR]: 'mètres',
    [languageIds.deDE]: 'zoll',
  },
  feet: {
    [languageIds.enUS]: 'feet',
    [languageIds.esES]: 'pies',
    [languageIds.enGB]: 'feet',
    [languageIds.frCA]: 'mètres',
    [languageIds.frFR]: 'mètres',
    [languageIds.deDE]: 'meter',
  },
  squareFeet: {
    [languageIds.enUS]: 'square meters',
    [languageIds.esES]: 'metros\u00B2',
    [languageIds.enGB]: 'square meters',
    [languageIds.frCA]: 'mètres carrés',
    [languageIds.frFR]: 'mètres carrés',
    [languageIds.deDE]: 'quadratmeter',
  },
  cubicFeet: {
    [languageIds.enUS]: 'cubic meters',
    [languageIds.esES]: 'metros\u00B3',
    [languageIds.enGB]: 'cubic meters',
    [languageIds.frCA]: 'mètres cubes',
    [languageIds.frFR]: 'mètres cubes',
    [languageIds.deDE]: 'kubikmeter',
  },
  cubicYard: {
    [languageIds.enUS]: 'cubic meters',
    [languageIds.esES]: 'metros\u00B3',
    [languageIds.enGB]: 'cubic meters',
    [languageIds.frCA]: 'mètres cubes',
    [languageIds.frFR]: 'mètres cubes',
    [languageIds.deDE]: 'kubikmeter',
  },
  squareYard: {
    [languageIds.enUS]: 'square meters',
    [languageIds.esES]: 'metros\u00B2',
    [languageIds.enGB]: 'square meters',
    [languageIds.frCA]: 'mètres carrés',
    [languageIds.frFR]: 'mètres carrés',
    [languageIds.deDE]: 'quadratmeter',
  },
};



// WEBPACK FOOTER //
// ./src/lib/localization/metric.js